import { Pipe, PipeTransform } from '@angular/core';
import { globalConst } from 'src/app/shared/helpers/constants';

@Pipe({
  name: 'userType'
})
export class UserTypePipe implements PipeTransform {

  transform(type: string): string {
    switch (type) {
      case globalConst.defaults.user.admin:
        return 'Administrador';
      case globalConst.defaults.user.tecnical:
        return 'Técnico';
      case globalConst.defaults.user.client:
        return 'Cliente';
      default:
        return undefined;
    }
  }
}
